export default Object.freeze({
  COMPANY: 'company', // Company logo
  APP: 'app', // App logo (Ready2Work)
})
